import { onFind } from '@elements/init-modules-in-scope';
import { on, removeAttribute, setAttribute, findIn } from '@elements/dom-utils';

const selectors = {
    base: '.js-new-product-popup',
    close: '.js-new-product-popup__close'
}

const cookieName = 'lastClosedNewProductPopup';

export function init() {
    onFind(selectors.base, (baseElement) => {
        if(baseElement.dataset.newProudctPopupId && !currentPopupWasAlreadyDismissed(baseElement.dataset.newProudctPopupId)) {
            removeAttribute('hidden', baseElement);
        }

        const closeButton = findIn(selectors.close, baseElement);
        console.log("baseElement", baseElement, "closeButton", closeButton)

        on('click', () => dismissPopup(baseElement), closeButton);
        on('click', () => dismissPopup(baseElement), baseElement);
    })
}

function dismissPopup(baseElement) {
    setCookie(cookieName, baseElement.dataset.newProudctPopupId);
    setAttribute('hidden', 'hidden', baseElement);
}

function currentPopupWasAlreadyDismissed(id) {
    const lastClosedPopup = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${cookieName}=`))
        ?.split('=')[1];

    return lastClosedPopup === id;
}
function setCookie(name, value) {
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/`;
}